import { createContext, useContext } from 'react';

export type RadioChoiceCardGroupContextProps = {
  error: boolean;
};

export const RadioChoiceCardGroupContext = createContext<RadioChoiceCardGroupContextProps>({
  error: false,
});

export const useRadioChoiceCardGroupContext = () => useContext(RadioChoiceCardGroupContext);

export type RadioChoiceCardFrameContextProps = {
  checked: boolean;
  disabled: boolean;
  truncate: boolean;
};

export const RadioChoiceCardFrameContext = createContext<RadioChoiceCardFrameContextProps>({
  checked: false,
  disabled: false,
  truncate: true,
});

export const useRadioChoiceCardFrameContext = () => useContext(RadioChoiceCardFrameContext);
